import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import logo from '../assets/gif/load1.gif';
class Loading extends Component {
  render() {
    const styles = {
      modalContent: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      },
      loadingContent: {
        display: 'flex',
        justifyContent: 'center',
        padding: 15
      },
      loading: {
        width: 'auto',
        height: 'auto'
      }
    };

    return (
      <Modal
        className="static-modal" 
        show={true}
        bsSize="sm"
        style={styles.modalContent}>
        <div style={styles.loadingContent}>
          <img src={logo} alt="loading..." style={styles.loading} />
        </div>
      </Modal>
    );
  }
}

export default Loading;
